import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from "./reportWebVitals";
import './index.css';
import App from './App';
import { createStore } from "redux";
import { Provider } from "react-redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { combineReducers } from 'redux';
import { authReducer }     from "./reducers/authReducer";
import { chatbotReducer }  from "./reducers/chatbotReducer";
import { rpaAgentReducer } from "./reducers/rpaAgentReducer"; // ⭐ NEW
import { BrowserRouter as Router } from 'react-router-dom';

// Combine reducers
const rootReducer = combineReducers({
  auth:     authReducer,
  chatbot:  chatbotReducer,
  rpaAgent: rpaAgentReducer, // ⭐ NEW — selected doc/project context for the agent chat
});

const store = createStore(rootReducer, composeWithDevTools());

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* <CartProvider> Wrap the App with CartProvider */}
        <Router>
          <App />
        </Router>
      {/* </CartProvider> */}
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
